import {
  setAttributes,
} from './util';
import { escapeHTML } from '../../../util/util';

/**
 * Basic column selector
 * @param  {string} options.key         [key of the selector]
 * @param  {string} options.label       [user visible label]
 * @param  {object} options.events      [object of callback functions]
 * @param  {object} options.isSelected  [if item is selected]
 * @param  {object} options.isAll       [if item is an all value]
 * @return {DOM}                        [dom element]
 */
export function columnSelector({
  key,
  parentSlug,
  label,
  events,
  isSelected = false,
  isAll = false,
}) {
  const pWrapper = document.createElement('p');
  if (isAll) {
    pWrapper.setAttribute('class', 'select-all');
  }
  const wrapper = document.createElement('column-selector');
  wrapper.classList.add('column-selector');
  if (isAll) {
    wrapper.classList.add('select-all');
  }

  const attr = {
    type: 'checkbox',
    name: 'chk',
    class: `styled ${isAll ? 'select-all' : ''}`,
    id: key,
    value: key,
  };

  const input = setAttributes(
    document.createElement('input'),
    attr
  );

  if (isSelected) {
    input.checked = true;
  }

  Object.keys(events).forEach((event) => {
    if (event === 'toggleSingleSelect' && !isAll) {
      input.addEventListener('click', events[event]);
    } else if (event === 'toggleAllSelect' && isAll) {
      input.addEventListener('click', events[event]);
    }
  });

  document.addEventListener('clearAll', () => {
    if (input.classList.contains('select-all')) {
      const event = new CustomEvent('selectAllOff', {
        detail: {
          keys: [input.id.replace('-all', '')],
        },
      });
      document.dispatchEvent(event);
      return;
    }
    input.checked = false;
  });

  if (isAll) {
    document.addEventListener('selectAllOff', (evt) => {
      if (evt.detail.keys.join('--').indexOf(key.replace('-all', '')) > -1) {
        input.checked = false;
        document.querySelector(`label[for="${key}"]`).innerHTML =
          escapeHTML(dcStrings.selectAll);
      }
    });
  }

  document.addEventListener('selectAll', (evt) => {
    // If a parent causes this
    if ((parentSlug || []).indexOf(evt.detail.parentSlug) > -1 ||
      evt.detail.wrapups.indexOf(key) > -1
    ) {
      input.checked = evt.detail.checked;
    }
  });

  wrapper.appendChild(input);
  wrapper.appendChild(labelTemplate({ key, label, isAll, isSelected }));
  pWrapper.appendChild(wrapper);
  return pWrapper;
}

/**
 * Create the template label for the columnSelector
 * @param  {string}  options.key        [key for the input]
 * @param  {string}  options.label      [label]
 * @param  {Boolean} options.isAll      [if the selector is an all]
 * @param  {Boolean} options.isSelected [if it's selected (or should be)]
 * @return {string}                     [interpolated string]
 */
function labelTemplate({ key, label, isAll = false, isSelected = false }) {
  const elm = document.createElement('label');
  elm.setAttribute('for', key);
  if (isAll) {
    // elm.innerHTML = `${isSelected ? 'Unselect' : 'Select'} All`;
    elm.innerHTML =
      escapeHTML(isSelected ? dcStrings.unselectAll : dcStrings.selectAll);
  } else {
    elm.innerHTML = escapeHTML(label);
  }
  return elm;
}

// Default export for testing
export default {
  columnSelector,
  labelTemplate,
};



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./js/directives/refineColumns/children/columnSelector.js
 **/